module.exports = __webpack_public_path__ + "static/media/megumin-win.ecc00606.png";